import { getFormatMixins, isFieldOrDatumDef, isValueDef } from '../../../channeldef';
import { signalOrValueRef } from '../../common';
import { formatSignalRef } from '../../format';
import { wrapCondition } from './conditional';
export function text(model) {
  var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
  var channelDef = model.encoding[channel];
  return wrapCondition({
    model: model,
    channelDef: channelDef,
    vgChannel: channel,
    mainRefFn: function mainRefFn(cDef) {
      return textRef(cDef, model.config);
    },
    invalidValueRef: undefined // text encoding doesn't have continuous scales and thus can't have invalid values
  });
}
export function textRef(channelDef, config) {
  var expr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'datum';
  // text
  if (channelDef) {
    if (isValueDef(channelDef)) {
      return signalOrValueRef(channelDef.value);
    }
    if (isFieldOrDatumDef(channelDef)) {
      var _getFormatMixins = getFormatMixins(channelDef),
        format = _getFormatMixins.format,
        formatType = _getFormatMixins.formatType;
      return formatSignalRef({
        fieldOrDatumDef: channelDef,
        format: format,
        formatType: formatType,
        expr: expr,
        config: config
      });
    }
  }
  return undefined;
}